<template>
<div class="card" v-loading="loading">
  <div class="card-header">
    <div class="row">
      <div class="col-md-6">
        <h4 class="card-title">
          <i class="ti-user"></i> Dados do Cliente
        </h4>
      </div>

      <div class="col-md-6 text-right">
        <router-link
          v-if="showEditButton && customer._id"
          :to="{name: 'customers.edit', params: {id: customer._id}}"
        >
          <a
            v-if="$can('customers.edit')"
            class="btn btn-fill btn-primary btn-sm btn"
          >
            <i class="ti-pencil"></i> Editar
          </a>
        </router-link>
      </div>
    </div>
  </div>
  <div class="card-content">
    <dl class="dl-horizontal">
      <dt>UC</dt>
      <dd>
        <a
          @click="$router.push({ name: 'customer.detail', params: { id: customer._id } })"
        >{{ customer.uc }}</a>
      </dd>

      <dt>Nome do titular</dt>
      <dd>{{ customer.holder }}</dd>

      <dt>Conhecido como</dt>
      <dd>{{ customer.aka }}</dd>

      <dt>Nome da mãe</dt>
      <dd>{{ customer.motherName ? customer.motherName : '-'}}</dd>

      <dt>CPF</dt>
      <dd>{{ customer.cpf }}</dd>

      <dt>Data de nascimento</dt>
      <dd>{{ customer.birthdate }}</dd>

      <dt>
        <strong>NIS</strong>
      </dt>
      <dd>{{ customer.nis }}</dd>
    </dl>

    <dl class="dl-horizontal">
      <dt>Telefone 1</dt>
      <dd>{{ phone1 }}</dd>

      <dt>Telefone 2</dt>
      <dd>{{ phone2 }}</dd>
    </dl>

    <dl
      v-if="hasAdditionalData"
      class="dl-horizontal"
    >
      <dt v-if="showEditButton"></dt>

      <dd
        v-if="showEditButton"
        class="text-right"
      >
        <button
          v-if="$can('customers.edit|customers.tickets')"
          @click="editAdditionalData()"
          class="btn btn-fill btn-primary btn-sm btn"
        >
          <i class="ti-pencil"></i> Editar
        </button>
      </dd>

      <dt>Endereço</dt>

      <dd v-if="customer.hasOwnProperty('address')">
        {{ customer.address.street }}, {{ customer.address.number }}
        <br>
        {{ customer.address.neighborhood }}, {{ customer.address.city }} - CEP: {{ customer.address.zip }}
      </dd>
      <dd v-else>-</dd>

      <dt>Complemento</dt>
      <dd
        v-if="customer.hasOwnProperty('address')"
      >{{ customer.address.complement ? customer.address.complement : '-' }}
      </dd>
      <dd v-else>-</dd>
    </dl>
    <dl class="dl-horizontal">
      <dt>Criado por:</dt>
      <dd>{{ users[customer.userId] }}</dd>
    </dl>
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CustomerCard',

  props: {
    customer: {
      required: true,
      type: Object
    },
    showEditButton: {
      default: true,
      type: Boolean
    }
  },

  computed: {
    ...mapGetters('users', { users: 'usersIdName', loading: 'loading' }),

    hasAdditionalData () {
      return this.customer.hasOwnProperty('address') && this.customer.address.complement && this.customer.address.complement.length > 0
    },

    phone1 () {
      return this.customer.hasOwnProperty('phone') && this.customer.phone[0] ? this.customer.phone[0] : this.customer.hasOwnProperty('phone1') ? this.customer.phone1 : '-'
    },

    phone2 () {
      return this.customer.hasOwnProperty('phone') && this.customer.phone[1] ? this.customer.phone[1] : this.customer.hasOwnProperty('phone2') ? this.customer.phone2 : '-'
    }
  },

  methods: {
    ...mapActions('users', {
      fetchUsers: 'fetchAll'
    }),
    editAdditionalData () {
      this.$emit('editAdditionalData', this.customer)
    }
  },

  mounted () {
    this.fetchUsers({ limit: 999 })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Customers/CustomerCard.vue